export const CAMPAIGN_STEPS = [
  { id: 1, label: 'Goal & Dates', description: 'Campaign basics' },
  { id: 2, label: 'Screens', description: 'Pick locations' },
  { id: 3, label: 'Slots', description: 'Time & frequency' },
  { id: 4, label: 'Preview & Create', description: 'Review & submit' },
] as const;

export const CAMPAIGN_GOALS = [
  { key: 'AWARENESS', label: 'Awareness' },
  { key: 'REACH', label: 'Reach' },
  { key: 'LEAD_GENERATION', label: 'Lead Generation' },
  { key: 'ANNOUNCEMENT', label: 'Announcement' },
  { key: 'OTHER', label: 'Other' },
] as const;

export const AD_CATEGORIES: Record<string, string> = {
  MARKETING_PROMOTIONAL: 'Marketing/Promotional Ads',
  ENTERTAINMENT: 'Entertainment Ads',
  PUBLIC_SERVICE: 'Public Service Announcement Ads',
  EVENT_PROMOTION: 'Event Promotion Ads',
  POLITICAL_CAMPAIGN: 'Political Campaign Ads',
  EDUCATIONAL_INFORMATIONAL: 'Educational/Informational Ads',
  COMMUNITY_ENGAGEMENT: 'Community Engagement Ads',
  PRODUCT_LAUNCH: 'Product Launch Ads',
  SEASONAL_HOLIDAY: 'Seasonal/Holiday Ads',
  SPONSORSHIP_PARTNERSHIP: 'Sponsorship/Partnership Ads',
};

/** AI audience category uses display labels (legacy API contract). */
export const AI_AUDIENCE_CATEGORIES = [
  'Marketing/Promotional',
  'Entertainment',
  'Public Service Announcement',
  'Event Promotion',
  'Political Campaign',
  'Educational/Informational',
  'Community Engagement',
  'Product Launch',
  'Seasonal/Holiday',
  'Sponsorship/Partnership',
] as const;

export const AD_DURATIONS = ['15', '30', '45', '60'] as const;

export const MIN_CAMPAIGN_AMOUNT = 500;
/** Max payable campaign order (incl. tax). Above this, launch/pay is blocked. */
export const MAX_CAMPAIGN_AMOUNT = 100_000;
export const MIN_AD_DURATION = 10;
export const MAX_AD_DURATION = 300;
export const MAX_SCREEN_SELECTION = 10;
export const AI_SESSION_SECONDS = 600;
export const EAP_OPTIONS = [
  {
    key: 'EAP-Elite',
    label: 'EAP—Elite (High professional & business density)',
  },
  {
    key: 'EAP-Advanced',
    label: 'EAP—Advanced (Educated, high-value work zones)',
  },
  {
    key: 'EAP-Growth',
    label: 'EAP—Growth (SME & upwardly mobile zones)',
  },
  {
    key: 'EAP-Stable',
    label: 'EAP—Stable (Salaried, stable income zones)',
  },
  {
    key: 'EAP-Developing',
    label: 'EAP—Developing (Skilled & informal economy zones)',
  },
  {
    key: 'EAP-Emerging',
    label: 'EAP—Emerging (Semi-skilled workforce zones)',
  },
  {
    key: 'EAP-Basic1',
    label: 'EAP—Basic 1 (Low-income activity zone)',
  },
  {
    key: 'EAP-Basic2',
    label: 'EAP—Basic 2 (Lower middle income activity zone)',
  },
  {
    key: 'EAP-Essential1',
    label: 'EAP—Essential 1 (Economically constrained zone)',
  },
  {
    key: 'EAP-Essential2',
    label: 'EAP—Essential 2 (Economically constrained zone)',
  },
] as const;

export const ALI_OPTIONS = [
  {
    key: 'ALI-Core',
    label: 'ALI—Core (Basic infrastructure & spending)',
  },
  {
    key: 'ALI-Access',
    label: 'ALI—Access (Entry-level lifestyle access)',
  },
  {
    key: 'ALI-Connected',
    label: 'ALI—Connected (Digital & service access)',
  },
  {
    key: 'ALI-Comfort',
    label: 'ALI—Comfort (Middle-tier lifestyle zones)',
  },
  {
    key: 'ALI-Enhanced',
    label: 'ALI—Enhanced (Upper-middle consumption)',
  },
  {
    key: 'ALI-Premium',
    label: 'ALI—Premium (High discretionary spending)',
  },
  {
    key: 'ALI-Affluent',
    label: 'ALI—Affluent (Luxury-oriented zones)',
  },
  {
    key: 'ALI-Elite+',
    label: 'ALI—Elite+ (Ultra-premium zones)',
  },
] as const;
